import { Option } from '../../Select/Select';

export const mapWarehousesToOptions = (warehouses?: any[]): Option[] =>
  warehouses?.map(c => ({
    label: c.name,
    value: c.id?.toString() ?? '',
  })) || [];

export const findWarehouseOption = (options: Option[], warehouseId?: number) =>
  options.find(opt => opt.value === warehouseId?.toString());
